import Vue from 'vue'
import Vuex from 'vuex'
import app from '../../main' // import the instance
import axios from 'axios' // remove comment if yu needed
import Crud from '../crud'
const model = (payload) => ({
  // columns
  id: payload.id
})
var crud = new Crud('Receptions', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  receptions: []
}

const mutations = {
  ...crud.mutations
}

const actions = {
  ...crud.actions,
  printReport ({ commit }, payload) {
    app.$Progress.start()
    try {
      window.open(axios.defaults.baseURL + `/receptions/${payload}/export`)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  }
}

const getters = {
  ...crud.getters,
  receptions: state => state.receptions
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
